export default __webpack_public_path__ + "static/media/Logo.3f3c68e0.svg";